{
  "MACROS": {
    "HEADER": "Makrokomandos",
    "DESCRIPTION": "A macro is a set of saved actions that help customer service agents easily complete tasks. The agents can define a set of actions like tagging a conversation with a label, sending an email transcript, updating a custom attribute, etc., and they can run these actions in a single click.",
    "LEARN_MORE": "Learn more about macros",
    "COUNT": "{n} macro | {n} macros",
    "HEADER_BTN_TXT": "Pridėti naują makrokomandą",
    "HEADER_BTN_TXT_SAVE": "Išsaugoti makrokomandą",
    "LOADING": "Gaunama makrokomanda",
    "SEARCH_PLACEHOLDER": "Search macros...",
    "NO_RESULTS": "No macros found matching your search",
    "ERROR": "Kažkas nepavyko. Bandykite dar kartą",
    "ORDER_INFO": "Makrokomandos bus paleistos ta tvarka, kuria pridėsite veiksmus. Galite juos pertvarkyti vilkdami už rankenos šalia kiekvieno mazgo.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Makrokomandos pavadinimas",
          "PLACEHOLDER": "Įveskite makrokomandos pavadinimą",
          "ERROR": "Kuriant makrokomandą būtinas pavadinimas"
        },
        "ACTIONS": {
          "LABEL": "Veiksmai"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Makrokomanda sėkmingai pridėta",
        "ERROR_MESSAGE": "Nepavyko sukurti makrokomandos, bandykite dar kartą vėliau"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Vardas",
        "CREATED BY": "Sukurtas",
        "LAST_UPDATED_BY": "Paskutinį kartą atnaujino",
        "VISIBILITY": "Matomumas",
        "ACTIONS": "Veiksmai"
      },
      "404": "Nerasta makrokomandų"
    },
    "DELETE": {
      "TOOLTIP": "Ištrinti makrokomandą",
      "CONFIRM": {
        "MESSAGE": "Ar tikrai norite ištrinti ",
        "YES": "Taip, Ištrinti",
        "NO": "Ne"
      },
      "API": {
        "SUCCESS_MESSAGE": "Makrokomanda sėkmingai ištrinta",
        "ERROR_MESSAGE": "Ištrinant makrokomandą įvyko klaida. Pabandykite dar kartą vėliau"
      }
    },
    "VIEW": {
      "TOOLTIP": "View macro"
    },
    "EDIT": {
      "TOOLTIP": "Redaguoti makrokomandą",
      "API": {
        "SUCCESS_MESSAGE": "Makrokomanda sėkmingai atnaujinta",
        "ERROR_MESSAGE": "Nepavyko atnaujinti makrokomandos. Pabandykite dar kartą vėliau"
      }
    },
    "EDITOR": {
      "START_FLOW": "Pradėti srautą",
      "END_FLOW": "Baigti srautą",
      "LOADING": "Gaunama makrokomanda",
      "ADD_BTN_TOOLTIP": "Pridėti naują veiksmą",
      "DELETE_BTN_TOOLTIP": "Ištrinti Veiksmą",
      "VISIBILITY": {
        "LABEL": "Makrokomandos matomumas",
        "GLOBAL": {
          "LABEL": "Viešas",
          "DESCRIPTION": "Ši makrokomanda yra viešai prieinama visiems šios paskyros agentams.",
          "CREATE_DISABLED_DESCRIPTION": "Only administrators can create public macros.",
          "EDIT_DISABLED_DESCRIPTION": "Only administrators can edit public macros."
        },
        "PERSONAL": {
          "LABEL": "Privatus",
          "DESCRIPTION": "Ši makrokomanda bus prieinama tik jums ir nepasiekiama kitiems."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Vykdyti",
      "PREVIEW": "Peržiūrėti makrokomandą",
      "EXECUTED_SUCCESSFULLY": "Sėkmingai įvykdyta makrokomanda"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Reikalinga vertė",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Assign a Team",
      "ASSIGN_AGENT": "Assign an Agent",
      "ADD_LABEL": "Add a Label",
      "REMOVE_LABEL": "Remove a Label",
      "REMOVE_ASSIGNED_AGENT": "Remove Assigned Agent",
      "REMOVE_ASSIGNED_TEAM": "Remove Assigned Team",
      "SEND_EMAIL_TRANSCRIPT": "Send an Email Transcript",
      "MUTE_CONVERSATION": "Tildyti pokalbį",
      "SNOOZE_CONVERSATION": "Atidėti Pokalbį",
      "RESOLVE_CONVERSATION": "Išspręsti pokalbį",
      "SEND_ATTACHMENT": "Send Attachment",
      "SEND_MESSAGE": "Send a Message",
      "CHANGE_PRIORITY": "Pakeisti Prioritetą",
      "ADD_PRIVATE_NOTE": "Add a Private Note",
      "SEND_WEBHOOK_EVENT": "Send Webhook Event"
    },
    "PRIORITY_TYPES": {
      "NONE": "Nėra",
      "LOW": "Žemas",
      "MEDIUM": "Vidutinis",
      "HIGH": "Aukštas",
      "URGENT": "Skubus"
    }
  }
}
